import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormField } from '../../../models/form-field';
import { FormGroup } from '@angular/forms';
import { DynamicFormService } from '../../../services/dynamic-form.service';
import { EsquemaService } from '../../../services/esquema.service';
import { EsquemaVariableService } from '../../../services/esquema-variable.service';
import { ErroresService } from '../../../core/services/errores.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { GruposLiquidacion } from '../../../models/gruposLiquidacion';
import { GruposLiquidacionService } from '../../../services/gruposLiquidacion.service';


@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.css']
})
export class DynamicFormComponent implements OnInit, OnChanges
{
  @Input() esquemaVariables: any;
  @Input() esquemaId: number;
  @Input() liqEspecial: boolean;
  @Input() liqBaja: boolean;
  form: FormGroup;
  payLoad = ' ';
  formFields: FormField<string>[] = [];
  liquidando: boolean = false;
  valores: [];
  liquidacionInvalida: boolean = false;
  MensajeError: string = '';
  gruposLiquidaciones: GruposLiquidacion[];

  constructor( private router: Router, 
    private dialog: MatDialog,
    private dynamicFormService: DynamicFormService, 
    private esquemaService: EsquemaService,
    private esquemaVariableService: EsquemaVariableService,
    private erroresService: ErroresService,
    private snackBar: MatSnackBar,
    private gruposLiquidacionService: GruposLiquidacionService ) { }

  ngOnInit(): void
  {
    this.gruposLiquidacionService.getAll().subscribe(
      data =>
      {
        this.gruposLiquidaciones = data;
      }
    );
  }

  verResultados()
  {
    if(this.form.controls.SIMULACION.value){
      this.router.navigate(['/configuracion/resultadosliqsimu', {opcion: 1}]);
    }else{
      this.router.navigate(['/configuracion/resultadosliq', {opcion: 0}]);
    }    
  }

  async onSubmit()
  {
    if (await this.validarDatos())
    {
      this.liquidando = true;
      this.form.disable();

      if (this.form.controls['SIMULACION'].value == '')
      {
        this.form.controls['SIMULACION'].setValue(false);
      } else if (this.form.controls['SIMULACION'].value == 'True')
      {
        this.form.controls['SIMULACION'].setValue(true);
      }
      this.payLoad = JSON.stringify(this.form.getRawValue());
      this.payLoad = '{"esquemaid": '+ this.esquemaId +',' + this.payLoad.substring(1,this.payLoad.length);
      this.payLoad.valueOf()
      this.valores = JSON.parse(this.payLoad);
            
      this.esquemaVariableService.save(this.valores ).subscribe(
        response =>
        {
          this.esquemaService.liquidar(this.esquemaId, this.liqEspecial, this.liqBaja).subscribe(
            response =>
            {
              this.liquidando = false;
              this.form.enable();
              this.snackBar.open("La liquidación se lanzó con éxito.", "OK", { duration: 10000 });
            },
            error =>
            {
              this.liquidando = false;
              this.form.enable();
              this.erroresService.MostrarErrorByStatus(error, "Error al liquidar");
            }
          );
        },
        error =>
        {
          this.liquidando = false;
          this.form.enable();
          this.erroresService.MostrarErrorByStatus(error, "Error al liquidar");
        }
      );
    }
  }

  ngOnChanges(changes: SimpleChanges): void
  {
    this.liquidacionInvalida = false;
    this.formFields = [];
    if (changes.esquemaVariables.currentValue != undefined)
    {
      for (var i = 0; i < changes.esquemaVariables.currentValue.length; i++)
      {
        let esquema = changes.esquemaVariables.currentValue[i];
        let controlType;
        let type;
        let options = [];

        if ((esquema.name == "FECHA_PAGO" || esquema.name == "MOTIVO_PAGO") && !this.liqEspecial)
        {
          //Solo se incluyen en una liquidacion especial
          continue;
        }
        
        switch (esquema.dataType)
        {
          case 1:
            controlType = "textbox";
            type = "textbox";

            this.agregarControl(controlType, esquema, type, options, esquema.dataValue);
            break;
          case 2:
            controlType = "number";
            type = "number";

            this.agregarControl(controlType, esquema, type, options, esquema.dataValue);
            break;
          case 3:
            controlType = "date";
            type = "date";

            this.agregarControl(controlType, esquema, type, options, esquema.dataValue);
            break;
          case 4:
            controlType = "checkbox";
            type = "textbox";
            if (esquema.dataValue == 'False' || esquema.dataValue == 'false'){
              esquema.dataValue = '';
            }

            this.agregarControl(controlType, esquema, type, options, esquema.dataValue);
            break;
          case 5:
            controlType = "dateMonth";
            type = "textbox";

            this.agregarControl(controlType, esquema, type, options, esquema.dataValue);
            break;
          case 6:
            //controlType = "dropdown";
            //options = [
            //  { key: '01', value: 'Fin de mes' },
            //  { key: '02', value: 'Mes siguiente' },
            //  { key: '03', value: 'Quincenal' }
            //];
            break;
          case 7:
            controlType = "dropdown";

            this.esquemaVariableService.getDatosDeTabla(esquema.tabla).subscribe(
              response =>
              {
                let ultimoObjetoLiquidado : any;

                response.forEach(function (valor)
                {
                  if (valor.id.toString() === esquema.dataValue)
                  {
                    ultimoObjetoLiquidado = { id: valor.id, descripcion: valor.descripcion };
                  }
                  else
                  {
                    options.push({ id: valor.id, descripcion: valor.descripcion });
                  }
                });

                if (ultimoObjetoLiquidado != undefined)
                {
                  options.unshift(ultimoObjetoLiquidado);
                }
                  

                this.agregarControl(controlType, esquema, type, options, esquema.dataValue);
                this.generarForm();
              },
            );
            break;
          default:
            break;
        }       
      }

      this.generarForm();

    }
  }

  private generarForm() {
    this.formFields = this.formFields.sort((n1, n2) => n1.order - n2.order);
    this.form = this.dynamicFormService.toFormGroup(this.formFields);
  }

  private agregarControl(controlType: any, esquema: any, type: any, options: any[], dataValue: any) 
  {
    if (controlType != "checkbox") 
    {
      dataValue = null;
    }
    this.formFields.push(new FormField<string>({
          controlType: controlType,
          key: esquema.name,
          label: esquema.description,
          required: esquema.required,
          value: dataValue,
          type: type,
          options: options,
          order: esquema.orden
      }));
  }

  private async verEstadoNomina(tipoPeriodo: number) : Promise<boolean>
  {
    let estadoValido = true;
    let grupoLiquidacion = await this.gruposLiquidacionService.getById(tipoPeriodo).toPromise();
    if (grupoLiquidacion != null && grupoLiquidacion.estadoActual != 1) {
      //this.liquidacionInvalida = true;
      estadoValido = false;
      this.snackBar.open("Control de Nómina no habilitado para la ejecución de la Nómina.", "OK", { duration: 10000 });
    }
    return estadoValido;
  }

  private async validarDatos() : Promise<boolean>
  {
    this.liquidacionInvalida = false;
    this.MensajeError = "";
    
    let simu = this.form.get("SIMULACION").value;
    let tipo = this.form.get("TIPO_PERIODO").value;
    
    if (simu == false) 
    {
      let estadoValido = await this.verEstadoNomina(tipo);
      if (estadoValido == false) return false;
    }
    
    if (this.form.valid)
    {
      return true;
    }
    else
    {
      this.form.markAllAsTouched();
      return false;
    }
  }
}
